<ejs-dialog #addWidgetDialog
            class="dialog-min-height"
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="onCloseAddWidgetDialog()"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.home.dashboard.form.title' | translate}}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-4">
        <ejs-grid #grid
                  width="100%"
                  rowHeight="38"
                  [dataSource]="data"
                  (rowSelected)="onRowSelected($event)"
                  (actionBegin)="actionBegin($event)"
                  (actionComplete)="actionComplete($event)">
          <e-columns>
            <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
            <e-column field="widgetType"
                      headerText="{{'i18n.domain.home.dashboard.form.widget-type' | translate}}"
                      clipMode="EllipsisWithTooltip"
                      type="string">
                      <ng-template #template let-data>
                        <span>{{data.widgetType | translate}}</span>
                      </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div class="col-8">
        <app-add-widget-dialog-component-preview [selectedWidgetType]="selectedWidgetType" (widgetSelected)="parametersChanged($event)"></app-add-widget-dialog-component-preview>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2"
            (click)="onCloseAddWidgetDialog()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary"
            [disabled]="selectedWidgetType === null"
            (click)="select()">
      {{'i18n.shared.save' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
